export const messages = {
  'reward.accountStatistics.attention.content':
    'Прогноз вознаграждения может рассчитываться неверно, потому что по некоторым аккаунтам нет статистики. Чтобы получить ее, запустите сбор данных.<br />Прогноз вознаграждения обновится на следующий день после запуска.',
  'reward.accountStatistics.attention.runButton': 'Запустить сбор данных',
  'reward.accountStatistics.run.error':
    'Не получилолсь запустить сбор данных. Обратитесь в Службу Заботы.',
  'reward.accountStatistics.run.success':
    'Сбор данных запущен. Прогноз вознаграждения обновится завтра.',
  'reward.additional.frame.moreThanPrev':
    'Снова в плюсе! Вознаграждение выросло — сейчас оно<br />выше, чем в прошлом месяце',
  'reward.additional.frame.nextRatio':
    'Можно поднять процент вознаграждения — для этого<br />надо увеличить долю РСЯ до {nextRatio}%',
  'reward.additional.frame.ratioMoreThanMax.vkAndMt':
    'Так держать! Сохраняйте долю myTarget и ВКонтакте<br />выше {ratio}%, чтобы процент вознаграждения не уменьшился',
  'reward.additional.frame.ratioMoreThanMax.yandex':
    'Так держать! Сохраняйте долю РСЯ выше {ratio}%, чтобы<br />процент вознаграждения не уменьшился',
  'reward.additional.frame.turnoverLeft.progress':
    '<p>Сейчас {currentRatio}%</p><p>Осталось {leftRatio}%</p>',
  'reward.additional.frame.turnoverLeft.text.vkAndMt':
    'Начислим вознаграждение примерно <span>{reward}</span><br />Для этого увеличьте долю myTarget и ВКонтакте до <span>{ratio}%</span>',
  'reward.additional.frame.turnoverLeft.text.yandex':
    'Начислим вознаграждение примерно <span>{reward}</span><br />Для этого увеличьте долю РСЯ в Директе до <span>{ratio}%</span>',
  'reward.additional.frame.turnoverLeft.title': 'До вознаграждения — еще {turnoverLeft}',
  'reward.base.additional.dialog.content.conditions.vkAndMt':
    '<ul>\n  <li>доля myTarget и ВКонтакте в общем обороте агентства составляет от {minRatio}%,</li>\n  <li>агентство ведет рекламу хотя бы еще в одной системе.</li>\n</ul>',
  'reward.base.additional.dialog.content.conditions.vkAndMt.extra':
    'Выплачивается одновременно с базовым вознаграждением за месяц.',
  'reward.base.additional.dialog.content.conditions.vkAndMt.title': 'Рассчитывается, если:',
  'reward.base.additional.dialog.content.conditions.yandex':
    '<ol>\n  <li>Рассчитывается, если доля РСЯ в общем обороте агентства<br />в Яндекс.Директе составляет минимум 40%</li>\n  <li>Рассчитывается от оборота именно в РСЯ, а не в Яндекс.Директе</li>\n  <li>Выплачивается одновременно с базовым вознаграждением за месяц</li>\n</ol>',
  'reward.base.additional.dialog.content.percent.vkAndMt':
    'Размер дополнительного вознаграждения —<br />+{maxPercent}% к базовому',
  'reward.base.additional.dialog.content.percent.yandex': 'Дополнительное вознаграждение',
  'reward.base.additional.dialog.content.ratio.yandex':
    'Доля РСЯ в общем обороте агентства в Директе',
  'reward.base.additional.dialog.header.vkAndMt':
    'Дополнительное вознаграждение за долю<br />myTarget и ВКонтакте в обороте агентства',
  'reward.base.additional.dialog.header.yandex':
    'Дополнительное вознаграждение за долю РСЯ<br />в обороте Директа',
  'reward.base.additional.dialog.rewardLabel': 'Ваше вознаграждение',
  'reward.base.additional.frame.dialog.opener': 'Как это рассчитывается',
  'reward.base.additional.frame.ratio.vkAndMt': 'Доля ВК и mT',
  'reward.base.additional.frame.ratio.yandex': 'Ваша доля РСЯ',
  'reward.base.additional.frame.reward': 'Вознаграждение',
  'reward.base.additional.frame.title.vkAndMt': 'За долю myTarget и ВКонтакте в обороте агентства',
  'reward.base.additional.frame.title.yandex': 'За долю РСЯ в обороте Директа',
  'reward.base.additional.title': 'Дополнительное вознаграждение',
  'reward.base.additional.title.both': 'Дополнительное вознаграждение — примерно {money}',
  'reward.base.downloadDetailedReport': 'Скачать детализацию',
  'reward.base.downloadDetailedReport.warning': 'Данные собираются, попробуйте позже',
  'reward.base.fullTitle': 'Базовое вознаграждение — примерно {money}',
  'reward.base.subTitle': 'Зависит от оборота всех клиентов агентства. ',
  'reward.base.subTitleLink': 'Как рассчитывается',
  'reward.base.table.percent.max': 'максимальный',
  'reward.base.table.percent.next': 'следующий — {next}%',
  'reward.base.table.percentTitle': 'Процент\nвознаграждения',
  'reward.base.table.percentTooltip': 'Зависит от оборота всех клиентов агентства<br />за месяц.',
  'reward.base.table.percentTooltip.info':
    'В таблице указаны примерные суммы. Точные будут в отчете о вознаграждении.',
  'reward.base.table.percentTooltipLink': 'Что такое оборот',
  'reward.base.table.rewardTitle': 'Вознаграждение,\nбез НДС',
  'reward.base.table.systemTitle': 'Рекламная система',
  'reward.base.table.totalTurnoverTitle': 'Общий оборот,\nбез НДС',
  'reward.base.table.totalTurnoverTooltip':
    '<div>Оборот всех клиентов в сумме минус оборот аккаунтов:</div>\n<ul>\n <li>которые являются Ведущими партнерами Google;</li>\n <li>в которых рекламируются услуги агентства;</li>\n <li>которые подключены к eLama, а не созданы в сервисе.</li>\n</ul>\n<div>Перед расчетом вознаграждения из этой суммы вычитаются:</div>\n<ul>\n <li> бонусы рекламных систем;</li>\n <li>сумма возвратов с баланса рекламных систем на баланс<br />eLama за предыдущие месяцы.</li>\n</ul>\n<div>В таблице указаны примерные суммы. Точные будут в отчете<br />о вознаграждении.</div>',
  'reward.base.table.turnoverWithCapTitle': 'Оборот для расчета\nвознаграждения, без НДС',
  'reward.base.table.turnoverWithCapTooltip':
    '<div>Из оборота в Google Ads вычитается оборот аккаунтов, в которых: </div>\n<ul>\n<li>траты начались больше 182 дней назад;</li>\n<li>оборот меньше 75 ₽ (5 $) без НДС или больше 130 000 ₽ (2000 $) без НДС.</li>\n</ul>\n<div>В таблице указаны примерные суммы. Точные будут в отчете о вознаграждении.</div>',
  'reward.base.title': 'Ежемесячное вознаграждение',
  'reward.closed.text':
    'Сейчас рассчитать вознаграждение невозможно, поэтому мы<br />на время убрали расчеты и калькулятор',
  'reward.closed.title': 'Работаем над новыми условиями партнерской программы',
  'reward.conditions.clients': 'Минимум у 3 клиентов \nесть оборот',
  'reward.conditions.clients.h1': 'Сообщите нам, когда у {minClients} клиентов появится оборот',
  'reward.conditions.clients.link': 'Из чего состоит оборот',
  'reward.conditions.clients.messageButton': 'Сообщить',
  'reward.conditions.clients.p1':
    'И вы увидите данные об обороте всех клиентов в сумме. Когда оборот станет больше<br />{minSpend} без НДС, здесь появятся данные о вознаграждении.',
  'reward.conditions.clients.p2': 'Оборот — это сумма расходов и переводов клиентов.',
  'reward.conditions.clients.text': 'Оборот у {clients} из 3 клиентов',
  'reward.conditions.clients.unbanRequestError':
    'Сервис отправки сообщений недоступен.<br />Попробуйте позже',
  'reward.conditions.how': 'Как рассчитывается оборот',
  'reward.conditions.messageSent.content':
    'Обработаем его в течение 4 рабочих часов и ответим на <span>{email}</span>. После этого вы увидите данные об обороте всех клиентов или вознаграждении, если оборот больше {turnover} без НДС.',
  'reward.conditions.messageSent.title': 'Сообщение отправлено',
  'reward.conditions.popup.close': 'Закрыть',
  'reward.conditions.popup.text':
    '<span>Оборот агентства складывается из суммы расходов и переводов всех клиентов в течение месяца, а именно:</span>\n</br></br>\n\n<ul type="disc">\n<li>расходов в Яндекс.Директе и Google Ads без НДС;</li>\n<li>переводов в Facebook Ads без НДС и комиссии — это 10% от суммы перевода без НДС;</li>\n<li>переводов в сервисы программатик-рекламы, сервисы Яндекса (Дисплей, Карты, Навигатор), VK Спецпроекты, Calltouch, ВКонтакте, myTarget и другие системы и сервисы без НДС.</li>\n</ul>\n\n\n\n',
  'reward.conditions.popup.title': 'Как рассчитывается оборот\n',
  'reward.conditions.spend': 'Оборот всех клиентов в сумме — от 30 000 ₽ без НДС',
  'reward.conditions.spend.text': '{spend} из 30 000 ₽',
  'reward.conditions.title':
    'Вознаграждение за {month} начнет рассчитываться,\nесли выполнить это условие',
  'reward.conditions.unbanRejected.content':
    'Отправили на <span>{email}</span> письмо с подробностями',
  'reward.conditions.unbanRejected.title': 'Не можем принять данные<br />об обороте клиентов',
  'reward.current.calculator.header': 'Калькулятор вознаграждения',
  'reward.current.calculator.opener': 'Калькулятор вознаграждения',
  'reward.current.calculator.result.currentReward':
    'Базовое и дополнительное<br />вознаграждение сейчас',
  'reward.current.calculator.result.currentTurnover': 'Оборот сейчас',
  'reward.current.calculator.result.estimatedReward':
    'Базовое и дополнительное вознаграждение<br />с планируемым оборотом',
  'reward.current.calculator.result.estimatedTurnover': 'Планируемый оборот',
  'reward.current.calculator.result.info':
    '<p>Это только прогноз — данные могут измениться.</p>\n<p>\n  Процент вознаграждения рассчитывается до конца\n  <br />\n  календарного месяца.\n</p>',
  'reward.current.calculator.system.additionalText':
    'Выплачиваем вознаграждения в первые 182 дня существования<br />аккаунта',
  'reward.current.calculator.system.estimatedTurnover': 'Планируемый оборот, без НДС',
  'reward.current.calculator.systems.optionsLabel': 'Системы',
  'reward.current.calculator.systems.title': 'Рекламные системы',
  'reward.current.period.frame.h3':
    'Данные обновляются раз в день.<br />Точная сумма вознаграждения будет в отчете',
  'reward.current.period.frame.p3':
    'Отчет появится на этой странице в течение<br />первых 7 рабочих дней {month}',
  'reward.current.period.loading': 'Обновляем прогноз. Это может занять несколько минут.',
  'reward.current.period.oneDay': 'Вознаграждение за {date} г.',
  'reward.current.period.severalDays': 'Вознаграждение за период с {dateStart} по {dateEnd} г.',
  'reward.current.period.text.h1': 'примерно {money}',
  'reward.current.period.text.no-forecast':
    'Не можем показать прогноз. Проверьте, передаются ли данные<br />в статистику eLama. Если в статистике есть данные за вчерашний<br />день, напишите на ',
  'reward.current.period.text.p1': 'Вознаграждение за период с 1 по {date} г. —',
  'reward.current.period.text.p2': 'Прогноз на {date} — примерно <span>{money}</span>',
  'reward.current.period.tooltip':
    '<p>Рассчитывается на основании данных <br />о расходах и переводах всех клиентов за месяц, кроме сегодняшнего дня. Не учитываются данные за период, когда клиент работал сам или с другим агентством. </p>\n<p>Если у клиента не настроена статистика eLama, данные по его аккаунтам не попадут в прогноз. Поэтому итоговая сумма вознаграждения может быть больше.</p>',
  'reward.current.turnover.dialog.content.link': 'Как рассчитывается оборот',
  'reward.current.turnover.dialog.content.switcher': 'от {min} до {max}',
  'reward.current.turnover.dialog.content.switcher.onlyMin': 'от {min}',
  'reward.current.turnover.dialog.content.text1':
    'Процент базового вознаграждения зависит от оборота агентства. Оборот складывается из расходов и переводов всех клиентов агентства за месяц.',
  'reward.current.turnover.dialog.content.text2': 'Оборот, руб/мес без учета НДС',
  'reward.current.turnover.dialog.header': 'От чего зависит процент базового вознаграждения',
  'reward.current.turnover.dialog.opener': 'От чего зависит процент вознаграждения',
  'reward.current.turnover.increase': 'Где увеличится процент:',
  'reward.current.turnover.left.text': 'Чтобы увеличить процент вознаграждения, нужно еще',
  'reward.current.turnover.left.value': '{money} без НДС',
  'reward.current.turnover.title': 'Больше оборот —<br />больше вознаграждение',
  'reward.current.turnover.your.printMoney': '{value} млн {currency}',
  'reward.current.turnover.your.text': 'Ваш оборот',
  'reward.current.turnover.your.value': '{money} без НДС',
  'reward.postPayment.link': 'Смотреть условия',
  'reward.postPayment.modal.header': 'Почему решили скрыть предложение?',
  'reward.postPayment.modal.reason.alreadyUsing': 'Уже<br />используем',
  'reward.postPayment.modal.reason.notInteresting': 'Неинтересно<br />и навязчиво',
  'reward.postPayment.modal.reason.notTrusting': 'Не доверяю',
  'reward.postPayment.sendReason': 'Отправить',
  'reward.postPayment.text':
    'Подключаем ее бесплатно юрлицам и ИП<br />с рекламным бюджетом от 500 000 ₽ в месяц',
  'reward.postPayment.title':
    'Вы и ваши клиенты можете<br />увеличить оборот за счет <span>постоплаты</span>',
  'reward.prev.baseAndAdditional.additionalRewardLink': 'Дополнительное вознаграждение',
  'reward.prev.baseAndAdditional.baseRewardLink': 'Базовое вознаграждение',
  'reward.prev.baseAndAdditional.block.list':
    '<li>базовое — <span>{baseReward}</span></li>\n<li>дополнительное — <span>{additionalReward}</span></li>',
  'reward.prev.baseAndAdditional.block.title': 'Состоит из базового и дополнительного',
  'reward.prev.baseAndAdditional.tooltip.content':
    '<ul>\n  <li>долю РСЯ в обороте Директа;</li>\n  <li>долю ВКонтакте и myTarget в обороте всех клиентов агентства;</li>\n  <li>использование рекламных инструментов Директа.</li>\n</ul>',
  'reward.prev.baseAndAdditional.tooltip.content.approximate':
    'Указаны примерные суммы. Точные будут в отчете<br />о вознаграждении.',
  'reward.prev.baseAndAdditional.tooltip.p1':
    ' зависит от оборота всех клиентов<br />агентства за месяц.',
  'reward.prev.baseAndAdditional.tooltip.p2': ' рассчитывается за:',
  'reward.prev.calculated.bankAccount.frame.h3':
    'Вознаграждение рассчитано. Чтобы его получить, до 15 числа отправьте нам документы',
  'reward.prev.calculated.bankAccount.frame.link': 'Список документов и требования к ним',
  'reward.prev.calculated.bankAccount.frame.p1':
    'Отправить можно через систему ЭДО или почтой России.',
  'reward.prev.calculated.bankAccount.frame.p2':
    'Мы переведем вознаграждение в течение месяца после<br />того, как получим оригиналы документов.<br />Сканы не подойдут.',
  'reward.prev.calculated.bankAccount.frame.p3':
    'Если у вас появятся вопросы об отчете, напишите<br />на ',
  'reward.prev.calculated.button1': 'Скачать отчет',
  'reward.prev.calculated.button2': 'Соглашаюсь с отчетом',
  'reward.prev.calculated.frame.h3':
    'Вознаграждение рассчитано.<br />Чтобы получить его, согласитесь с отчетом',
  'reward.prev.calculated.frame.p1':
    'Проверьте отчет и согласитесь с ним в течение 5 рабочих<br />дней. Если не согласны с отчетом, напишите<br />на ',
  'reward.prev.calculated.frame.p2':
    'На шестой день отчет подтверждается автоматически.<br />После этого его не получится изменить.',
  'reward.prev.calculated.title': 'Вознаграждение за {month} г. —',
  'reward.prev.calculated.toast':
    'Отчет подтвержден.<br />Вы получите вознаграждение на баланс<br />{withdrawMethodName} в течение одного рабочего дня.',
  'reward.prev.calculating.frame.h3': 'Считаем вознаграждение за {month}',
  'reward.prev.calculating.frame.p1':
    'Точная сумма будет в отчете. Он появится на этой<br />странице в течение первых 7 рабочих дней {month}.',
  'reward.prev.calculating.text.h1': 'примерно {money}',
  'reward.prev.calculating.text.h3': 'Вознаграждение за {month} г. —',
  'reward.prev.notCalculated.reason.clients':
    'Потому что в этом месяце было меньше {minClients} клиентов с оборотом',
  'reward.prev.notCalculated.reason.turnover':
    'Потому что оборот всех клиентов за месяц меньше {minSpend} без НДС',
  'reward.prev.notCalculated.title': 'Вознаграждение за май не рассчитано',
  'reward.statistics.column.date': '{month} {year} г.',
  'reward.statistics.column.reward': '{reward}',
  'reward.statistics.prediction.amount': '{amount}',
  'reward.statistics.prediction.text': 'Примерная сумма вознаграждения к концу {month} — ',
  'reward.statistics.title': 'Вознаграждение за год, по месяцам',
  'reward.system.adwords': 'Google Ads',
  'reward.system.avito': 'Авито',
  'reward.system.calltouch': 'Calltouch',
  'reward.system.direct': 'Яндекс.Директ',
  'reward.system.empty': ' ',
  'reward.system.facebook': 'Facebook Ads',
  'reward.system.mytarget': 'myTarget',
  'reward.system.tiktok': 'Tiktok Ads',
  'reward.system.vkontakte': 'ВКонтакте',
  'reward.system.yadisplay': 'Яндекс.Дисплей',
  'reward.system.yanavigator': 'Яндекс.Бизнес',
  'reward.system.yandexNetwork': 'РСЯ',
  'reward.system.yandexSearch': 'Поиск',
  'reward.system.yandexZen': 'VK Спецпроекты',
  'reward.system.yaspravochnik': 'Яндекс Справочник',
  'UI-KIT.AttentionSmall.change': 'Исправить',
  'UI-KIT.ComboBox.noResults': 'Совпадений не найдено',
  'UI-KIT.Filter.apply': 'Применить',
  'UI-KIT.Filter.cancel': 'Отменить',
  'UI-KIT.Filter.chipLabel': 'Содержит',
  'UI-KIT.Filter.filterExist': 'Такой фильтр уже настроен',
  'UI-KIT.Filter.from': 'От',
  'UI-KIT.Filter.invalid': 'Некорректное значение',
  'UI-KIT.Filter.placeholder': 'Поиск по фильтрам и названию',
  'UI-KIT.Filter.to': 'До',
  'UI-KIT.InputFile.attach': 'Прикрепить файл',
  'UI-KIT.InputFile.dropOrClick': 'Перетащите в область или нажмите',
  'UI-KIT.InputFile.filesAttached': '{count, plural, one {# файл} few {# файла} other {# файлов}}',
  'UI-KIT.MultiInput.noResults': 'Нет совпадений',
  'UI-KIT.MultiSelect.all': 'Все',
  'UI-KIT.MultiSelect.moreValue':
    '{firstValue} и ещё {otherCount, plural, one {# значение} few {# значения} other {# значений}}',
  'UI-KIT.MultiSelectList.buttonOnly': 'Только',
  'UI-KIT.MultiSelectList.buttonSave': 'Применить',
  'UI-KIT.MultiSelectList.searchPlaceholder': 'Поиск',
  'UI-KIT.Paginaton.summary': '{visible} из {total}',
  'UI-KIT.SelectDates.optionPeriodName': 'Указать период',
  'UI-KIT.SelectDates.reset': 'Сбросить',
  'UI-KIT.SelectDates.submit': 'Применить',
  'UI-KIT.Wizard.edit': 'Изменить',
  'UI-KIT.Wizard.next': 'Принять',
  'UI-KIT.MultiSelectList.emptyFind': 'Совпадений не найдено'
}
